import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Button, Form } from "@towersystems/roam-common-native";
import { Page } from "@towersystems/roam-common-native";
import { CreateProductQuickKeyRootParamList } from "../../../../types";
import { useCreateTile } from "../../../../utilities/layout";
import { LayoutNodeProductForm } from "../../components";
import { useFormContext } from "react-hook-form";
import { LayoutNodeInput } from "@towersystems/roam-common/lib/generated-types";
import { Colors } from "react-native-ui-lib";
import { useSetupAllStartupEntities } from "../../../../utilities/setup";

export type CreateProductQuickKeyScreenProps = NativeStackScreenProps<
  CreateProductQuickKeyRootParamList,
  "CreateProductQuickKeyScreen"
>;

export function CreateProductQuickKeyScreen({
  navigation,
}: CreateProductQuickKeyScreenProps) {
  const { handleCreateTile } = useCreateTile();
  const { fetchAndSyncEntity } = useSetupAllStartupEntities();

  const {
    handleSubmit,
    formState: { isValid, isSubmitting },
  } = useFormContext<LayoutNodeInput>();

  const onCreate = async (values: LayoutNodeInput) => {
    return handleCreateTile(values).then(async () => {
      // reload tile data from server here
      await fetchAndSyncEntity("layout_nodes");
    });
  };

  const footer = (
    <Button
      label={"Save"}
      backgroundColor={Colors.action}
      color="white"
      disabled={!isValid || isSubmitting}
      onPress={handleSubmit(onCreate, console.log)}
    ></Button>
  );

  return (
    <Page
      title="Product POS quick key"
      secondaryTitle="Configure product quick key to quickly add a product to the sale"
      footer={footer}
    >
      <Form>
        <LayoutNodeProductForm />
      </Form>
    </Page>
  );
}
